
$(document).on('click', '.hk-element-sub-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...
  var selling_plan = parseInt($(this).attr('selling_plan'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.hk-element-sub-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-sub-trigger').hide();
$('.hk-sub-trigger[sub_tab="'+tab+'"]').show();
if (tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});



$(document).on('click', '.hk-element-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('data_tab'), 10); // 1,2,3...
  var quantity = parseInt($(this).attr('quantity'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.hk-element-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-quantity-trigger').hide().removeClass('hk-active');
$('.hk-quantity-trigger[data_tab="'+tab+'"]').show().addClass('hk-active');
$('.hk-quantity-trigger[quantity="'+quantity+'"]').show().addClass('hk-active');
$('.hk-checkout-button').attr('quantity',quantity);
var selected_title = $this.find('.hk-option-title').text();
$('.hk-pdp-pdt-sub-heading1 strong').text(selected_title);
});



$(document).on("click", "a[href='#ingredients']", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').addClass('hk-active');
});


$(document).on("click", ".hk-pdp-popup-top .hk-icon-with-text-flex .hk-element-image", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').removeClass('hk-active');
});




$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-pdp-pdt-sub-heading1').scrollIntoView({
    behavior: 'smooth'
  })
});





/*
$(document).ready(async function () {

  const $deliveryEl = $('.hk-pdp-pdt-estimated');

  if (!$deliveryEl.length) return;

  // ===== Date 5 days ahead =====
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 5);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formattedDate = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${days[futureDate.getDay()]}`;

  // ===== Default zipcode =====
  let zipcode = '00000';

  try {

    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();

    if (data && data.postal) {
      zipcode = data.postal;
    }

  } catch (e) {

    console.log('Zipcode fetch failed');

  }

  // ===== Replace placeholders =====
  let updatedHtml = $deliveryEl.html()
    .replace('[zipcode]', zipcode)
    .replace('[stock_date]', formattedDate);

  $deliveryEl.html(updatedHtml);

});
*/






$(document).ready(async function () {

  const $deliveryEl = $('.hk-pdp-pdt-estimated');

  if (!$deliveryEl.length) return;

  // ===== Date 5 days ahead =====
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 5);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formattedDate = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${days[futureDate.getDay()]}`;

  // ===== Default location =====
  let locationText = 'Your Area';

  try {

    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();

    if (data) {
      const state = data.region || '';
      const country = data.country_name || '';

      if (state && country) {
        locationText = `${state}, ${country}`;
      } else if (country) {
        locationText = country;
      }
    }

  } catch (e) {

    console.log('Location fetch failed');

  }

  // ===== Replace placeholders =====
  let updatedHtml = $deliveryEl.html()
    .replace('[zipcode]', locationText)
    .replace('[stock_date]', formattedDate);

  $deliveryEl.html(updatedHtml);

});








$(document).on("click", ".hk-add-lp-cart-variant-js:not(.hk-disabled)", function(e) {
$(this).parents('.hk-product-variant-right').addClass('hk-active');
$(this).parents('.hk-product-variant-right').find('input').val('1').trigger('change');
});
$(document).on("change", ".hk-product-variant-right input", function(e) {
update_step();
});

$(document).on('click', '.hk-quantity-plus-lp-cart:not([disabled])', function () {
    const $wrapper = $(this).closest('.hk-product-variant-quantity-flex');
    const $input = $wrapper.find('.hk-lp-cart-quantity');

    let qty = parseInt($input.val(), 10) || 0;
    $input.val(qty + 1).trigger('change');
update_step();
});

$(document).on('click', '.hk-quantity-minus-lp-cart', function () {
    const $wrapper = $(this).closest('.hk-product-variant-quantity-flex');
    const $input = $wrapper.find('.hk-lp-cart-quantity');

    let qty = parseInt($input.val(), 10) || 0;

    if (qty > 0) {
        $input.val(qty - 1).trigger('change');
    }
    if (qty == 1) {
       $input.parents('.hk-product-variant-right').removeClass('hk-active');
    }
update_step();
});






function update_step() {
var current_step = $('.hk-steps-js.hk-active');
var quantity = 0;
$('.hk-product-variant-right input').each(function(){
quantity = quantity + parseInt($(this).val());
});
$('.hk-pdt-heading2 p strong').text('Selected: '+quantity+'/4');
$('.hk-lp-cart-top-step').removeClass('hk-active');
$('.hk-quantity-plus-lp-cart').removeAttr('disabled');
$('.hk-add-lp-cart-variant-js').removeAttr('disabled');
var width = 0;
if(quantity > 0){
 $('button.hk-button.hk-checkout-button').removeAttr('disabled'); 
} else {
 $('button.hk-button.hk-checkout-button').attr('disabled','disabled'); 
}
if(quantity == 1){
    width = 18;
$('.hk-lp-cart-top-step').eq(0).addClass('hk-active');
}
if(quantity == 2){
    width = 43;
$('.hk-lp-cart-top-step').eq(0).addClass('hk-active');
$('.hk-lp-cart-top-step').eq(1).addClass('hk-active');
}
if(quantity == 3){
    width = 70;
$('.hk-lp-cart-top-step').eq(0).addClass('hk-active');
$('.hk-lp-cart-top-step').eq(1).addClass('hk-active');
$('.hk-lp-cart-top-step').eq(2).addClass('hk-active');
}
if(quantity >= 4){
    width = 100;
$('.hk-lp-cart-top-step').eq(0).addClass('hk-active');
$('.hk-lp-cart-top-step').eq(1).addClass('hk-active');
$('.hk-lp-cart-top-step').eq(2).addClass('hk-active');
$('.hk-lp-cart-top-step').eq(3).addClass('hk-active');
$('.hk-quantity-plus-lp-cart').attr('disabled','disabled');
$('.hk-add-lp-cart-variant-js').attr('disabled','disabled');
}
$('.hk-lp-cart-step-top-flex').css('--progress-width', width+'%');

if(quantity >= 4){
    quantity = 4;
}
if(quantity == 0){
    quantity = 1;
}

$('.hk-quantity-trigger').hide().removeClass('hk-active');
$('.hk-quantity-trigger[quantity="'+quantity+'"]').show().addClass('hk-active');
}





$(document).on("click", "a[href='#tab1']", function (e) {
  e.preventDefault();
 $('.hk-pdp-section1').hide();
 $('.hk-pdp-section1s').show();
});


$(document).on("click", "a[href='#tab2']", function (e) {
  e.preventDefault();
 $('.hk-pdp-section1').hide();
 $('.hk-pdp-section2s').show();
});



$(document).on('click', '.hk-product-variant-right', function () {
  var $this = $(this);
  var variant_id = $this.find('input.hk-lp-cart-quantity').attr('variant_id'); 

  if (!variant_id) return;

$('.hk-variant-trigger').hide().removeClass('hk-active');
$('.hk-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('hk-active');
$('.hk-variant-trigger[variant_id="'+variant_id+'"]').find('.slick-slider').each(function () {
if ($(this).hasClass('slick-initialized')) {
$(this).slick('refresh');
}
});
});

